var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.72217 2.24525C6.05064 2.24525 5.38568 2.37752 4.76526 2.6345C4.14485 2.89149 3.58113 3.26815 3.10628 3.743C2.63144 4.21784 2.25477 4.78157 1.99778 5.40198C1.7408 6.0224 1.60853 6.68735 1.60853 7.35889C1.60853 8.03042 1.7408 8.69538 1.99778 9.31579C2.25477 9.93621 2.63144 10.4999 3.10628 10.9748C3.58113 11.4496 4.14485 11.8263 4.76526 12.0833C5.38568 12.3403 6.05064 12.4725 6.72217 12.4725C8.07839 12.4725 9.37906 11.9338 10.3381 10.9748C11.297 10.0158 11.8358 8.71511 11.8358 7.35889C11.8358 6.00267 11.297 4.70199 10.3381 3.743C9.37906 2.78401 8.07839 2.24525 6.72217 2.24525ZM0.472168 7.35889C0.472168 3.90718 3.27046 1.10889 6.72217 1.10889C10.1739 1.10889 12.9722 3.90718 12.9722 7.35889C12.9722 10.8106 10.1739 13.6089 6.72217 13.6089C3.27046 13.6089 0.472168 10.8106 0.472168 7.35889Z",
    fill: "#164B35",
    stroke: "#164B35",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90844 5.65424L5.51867 10.044L3.31299 7.41163L4.17151 6.66731L5.57833 8.37753L9.10503 4.85083L9.90844 5.65424Z",
    fill: "#164B35",
    stroke: "#164B35",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.eada57904f99db9879ad79c619c56f3f.svg";
export { ForwardRef as ReactComponent };